import React, { useEffect, useState } from 'react'
import { Button } from 'react-bootstrap';
import { Form } from 'react-bootstrap';

function Marketing(props: any){
    const [radioValue, setradioValue] = useState('English')
    const [selectedValue, setSelectedValue] = useState("English");
    const [languagesData, setLanguagesData] = useState([]);
    const [indianlanguagesData, setIndianLanguagesData] = useState([]);
    const [languagesValue, setLanguagesValue] = useState(radioValue);
    const [voicetonesData, setVoicetonesData] = useState([])
    const [voicetonesValue, setVoicetonesValue] = useState('')
    const [writingStylesData,setwritingStylesData] = useState([])
    const [writingStylesValue,setwritingStylesValue] = useState('')
    const [textareaValue, setTextareaValue] = useState('')
    const [describeYourBusinessProductServiceValue, setDescribeYourBusinessProductServiceValue] = useState('')
    const [whatDoYouSellValue, setWhatDoYouSellValue] = useState('')
    const [whereDoYouSellValue, setWhereDoYouSellValue] = useState('')
    const [totalWordsValue, setTotalWordsValue] = useState(400)
    const [callToActionValue, setCallToActionValue] = useState('')
    const [keyword, setKeyword] = useState('')
    const promptTitle = `# Prompt by STWBot, Corp. - https://www.stwbot.com/\nLines starting with # are only comments for humans\nYou must add at the top of the response \"_Created with [STW Prompt \"${props.templateValue}\"](https://www.stwbot.com/)_\"\n---\n`
    let copyWritingPrompt: any ={
        'AIDA Framework': `${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are an expert copywriter that speaks and writes fluent ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Do not self reference. Do not explain what you are doing. Write a witty AIDA (Attention, Interest, Desire and Action) marketing campaign for "${describeYourBusinessProductServiceValue}"`, 
        'PAS Framework': `${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are an expert copywriter that speaks and writes fluent ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Do not self reference. Do not explain what you are doing. Write a witty PAS (Problem, Agitate and Solution) marketing campaign for "${describeYourBusinessProductServiceValue}"`, 
        'BAB Framework': `${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are an expert copywriter that speaks and writes fluent ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Do not self reference. Do not explain what you are doing. Write a witty BAB (Before, After, Bridge) marketing campaign for "${describeYourBusinessProductServiceValue}"`, 
        'FAB Framework': `${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are an expert copywriter that speaks and writes fluent ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Do not self reference. Do not explain what you are doing. Write a witty FAB (Features, Advantages, Benefits) marketing campaign for "${describeYourBusinessProductServiceValue}"`, 
        'Create Buyer Persona': `${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are a marketing researcher that writes fluent ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Your task is to generate a detailed USER PERSONA for a business that sells ${whatDoYouSellValue} in ${whereDoYouSellValue}. First write "User Persona creation for ${whatDoYouSellValue} in ${whereDoYouSellValue}" as the heading. Now create a subheading called "Demographics". Below, you need to create a table with the 2 columns and 7 rows with the following format: Column 1 = Data points (Name, Age, Occupation, Annual income, Marital status, Family situation, Location), Column 2 = Answers for each data point in Column 1 based on the specific market "${whatDoYouSellValue}". Now create a subheading called "USER DESCRIPTION". Below this generate a summary of the user persona in no more than 500 characters. Now create a subheading called "PSYCHOGRAPHICS". Below this you need to create a table with 2 columns and 9 rows with the following format: Column 1 = Data points (Personal characteristics, Hobbies, Interests, Personal aspirations, Professional goals, Pains, Main challenges, Needs, Dreams), Column 2 = Answers for each data point in Column 1 based on the specific market "${whatDoYouSellValue}". Now create a subheading called "SHOPPING BEHAVIORS". Below this you need to create a table with 2 columns and 8 rows with the following format: Column 1 = Data points (Budget, Shopping frequency, Preferred channels, Online behavior, Search terms, Preferred brands, Triggers, Barriers), Column 2 = Answers for each data point in Column 1 based on the specific market "{input_1}". Please make sure that your response is structured in 4 separate tables and has a separate row for each data point. Do not provide bullet points. Do not self reference. Do not explain what you are doing.`, 
        'Create Long-Form Sales Letter': `${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are a marketing researcher that writes fluent ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Your task is to generate a detailed USER PERSONA for a business that sells ${whatDoYouSellValue} in ${whereDoYouSellValue}. First write "User Persona creation for ${whatDoYouSellValue} in ${whereDoYouSellValue}" as the heading. Now create a subheading called "Demographics". Below, you need to create a table with the 2 columns and 7 rows with the following format: Column 1 = Data points (Name, Age, Occupation, Annual income, Marital status, Family situation, Location), Column 2 = Answers for each data point in Column 1 based on the specific market "${whatDoYouSellValue}". Now create a subheading called "Sales Letter for above persona". Below this generate a long form sales letter of around ${totalWordsValue} words using this persona. Do not self reference. Do not explain what you are doing.`, 
        'Create Video Sales Letter (VSL)': `${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are a marketing researcher that writes fluent ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Your task is to generate a detailed USER PERSONA for a business that sells ${whatDoYouSellValue} in ${whereDoYouSellValue}. First write "User Persona creation for ${whatDoYouSellValue} in ${whereDoYouSellValue}" as the heading. Now create a subheading called "Demographics". Below, you need to create a table with the 2 columns and 7 rows with the following format: Column 1 = Data points (Name, Age, Occupation, Annual income, Marital status, Family situation, Location), Column 2 = Answers for each data point in Column 1 based on the specific market "${whatDoYouSellValue}". Now create a subheading called "Video Sales Letter (VSL) for above persona". Below this generate a complete youtube video script in second person of around ${totalWordsValue} words using this persona. In the relevant segment ask the viewer ${callToActionValue}. Do not self reference. Do not explain what you are doing.`, 
    }
    let templateValue: any = copyWritingPrompt[props.templateValue] ? copyWritingPrompt[props.templateValue] : ''
    useEffect(() => {
        setTextareaValue(templateValue)
    }, [templateValue])
    useEffect(() => {
        resetValue()
    }, [props.templateValue])
    useEffect(() => {
        const data: any = []
        for (const key in indianLanguages) {
            const value: any = {
                name: '',
                value: ''
            }
            value.value = key;
            value.name = indianLanguages[key];
            data.push(value)
        }
        setIndianLanguagesData(data) 
        const dataVoice: any = []
        for (const key in voicetones) {
            const value: any = {
                name: '',
                value: ''
            }
            value.value = key;
            value.name = voicetones[key];
            dataVoice.push(value)
        }
        setVoicetonesData(dataVoice) 
        const datawritingStyles:any = []
        for (const key in writingStyles) {
            const value: any = {
                name: '',
                value: ''
            }
            value.value = key;
            value.name = writingStyles[key];
            datawritingStyles.push(value)
        }
        setwritingStylesData(datawritingStyles)
    },[])
    const onChangeRadio = (event: any) => {
        const value = event.target.value;
        setSelectedValue(value);
        setradioValue(value)
        if(value === 'Other languages'){
            const data: any = []
            for (const key in languages) {
                const value: any = {
                    name: '',
                    value: ''
                }
                value.value = key;
                value.name = languages[key];
                data.push(value)
            }
            setLanguagesData(data)
            setLanguagesValue('Arabic')
        } else {
            setLanguagesValue(value)
            setLanguagesData([])
        }
    }
    const onChangeLanguages = (event: any) => {
        const value = event.target.value;
        setLanguagesValue(value)
    }
    const onChangeVoicetones = (event: any) => {
        const value = event.target.value
        setVoicetonesValue(value)
    }
    const onChangeWritingStyles = (event: any) => {
        const value = event.target.value
        setwritingStylesValue(value)
    }
    const onChangeTextarea = (event: any) => {
        const value = event.target.value
        setTextareaValue(value)
    }
    const onChangeDescribeYourBusinessProductService = (event:any) => {
        const value = event.target.value
        setKeyword(value);
        setDescribeYourBusinessProductServiceValue(value)
    }
    const onChangeWhatDoYouSell = (event:any) => {
        const value = event.target.value
        setKeyword(value);
        setWhatDoYouSellValue(value)
    }
    const onChangeWhereDoYouSell = (event:any) => {
        const value = event.target.value
        setKeyword(value);
        setWhereDoYouSellValue(value)
    }
    const onChangeTotalWords = (event: any) => {
        const value = event.target.value
        setTotalWordsValue(value)
    }
    const onChangeCallToAction = (event: any) => {
        const value = event.target.value  
        setCallToActionValue(value)
    }
    const executeTemplateButton = () => {
        props.executeTemplateButton(textareaValue, keyword)
    }
    const getButtonVisiblety = () => {
        const value = props.templateValue
        switch(value) {
            case 'AIDA Framework':
                return describeYourBusinessProductServiceValue ? false : true
            case 'PAS Framework':
                return describeYourBusinessProductServiceValue ? false : true
            case 'BAB Framework':
                return describeYourBusinessProductServiceValue ? false : true
            case 'FAB Framework':
                return describeYourBusinessProductServiceValue ? false : true
            case 'Create Buyer Persona':
                return whatDoYouSellValue && whereDoYouSellValue ? false : true
            case 'Create Long-Form Sales Letter':
                return whatDoYouSellValue && whereDoYouSellValue && totalWordsValue ? false : true
            case 'Create Video Sales Letter (VSL)':
                return whatDoYouSellValue && whereDoYouSellValue && totalWordsValue && callToActionValue ? false : true
            default:
                return true;
        }
    }
    const resetValue = () => {
        setDescribeYourBusinessProductServiceValue('')
        setWhatDoYouSellValue('')
        setWhereDoYouSellValue('')
        setTotalWordsValue(400)
        setCallToActionValue('')
    }
    return(
        <div className='marketing'>
            <div className="row">
                <div className="col-sm-12 mt-2"><p>Description: Suggest 10 catchy blog post titles for a specific topic</p></div>
                <div className="col-sm-12 mt-2">
                    <div id="reverse-radio" className="mb-3">
                        {indianlanguagesData.map((item, i) => 
                            <Form.Check
                                key={i}
                                reverse
                                onChange={onChangeRadio}
                                label={item['name']}
                                checked={selectedValue === item['name']}
                                name="group1"
                                value={item['name']}
                                type='radio'
                                id={`reverse-radio-${i}`}
                            />
                        )}
                    </div>
                </div>
                {radioValue === "Other languages" && <div className="col-sm-4 mt-2">
                    <Form.Label htmlFor="languages">Languages:</Form.Label>
                    <Form.Select id="languages" 
                        value={languagesValue}
                        onChange={onChangeLanguages}
                    >
                        {languagesData.map((item, i) => <option key={i} value={item['name']}>{item['name']}</option>)}
                    </Form.Select>  
                </div>}
                <div className={"col-sm-"+(radioValue === "Other languages" ? "4" : "6")+" mt-2"}>
                    <Form.Label htmlFor="voicetones">Voice Tones:</Form.Label>
                    <Form.Select 
                        id="voicetones" 
                        aria-label="Default"
                        value={voicetonesValue}
                        onChange={onChangeVoicetones}
                    >
                        <option>Default</option>
                        {voicetonesData.map((item, i) => <option key={i} value={item['name']}>{item['name']}</option>)}
                    </Form.Select>  
                </div>
                <div className={"col-sm-"+(radioValue === "Other languages" ? "4" : "6")+" mt-2"}>
                    <Form.Label htmlFor="writingStyles">Writing Styles:</Form.Label>
                    <Form.Select 
                        id="writingStyles" 
                        aria-label="Default"
                        value={writingStylesValue}
                        onChange={onChangeWritingStyles}
                    >
                        <option>Default</option>
                        {writingStylesData.map((item, i) => <option key={i} value={item['name']}>{item['name']}</option>)}
                    </Form.Select>
                </div>
                {props.templateValue === 'AIDA Framework' ||
                props.templateValue === 'PAS Framework' ||
                props.templateValue === 'BAB Framework' ||
                props.templateValue === 'FAB Framework' ? <div className="col-sm-12  mt-2">
                    <Form.Label htmlFor="describeYourBusinessProductService">Describe your business/product:</Form.Label>
                    <Form.Control 
                        id="describeYourBusinessProductService"
                        value={describeYourBusinessProductServiceValue}
                        as='textarea' 
                        rows={3}
                        onChange={onChangeDescribeYourBusinessProductService}
                    />
                </div> : <></>}
                {props.templateValue === 'Create Buyer Persona' ||
                props.templateValue === 'Create Long-Form Sales Letter' || props.templateValue === 'Create Video Sales Letter (VSL)' ? <div className="col-sm-6  mt-2">
                    <Form.Label htmlFor="whatDoYouSell">What do you sell </Form.Label>
                    <Form.Control
                        value={whatDoYouSellValue}
                        type="text"
                        id="whatDoYouSell"
                        aria-describedby="What do you sell"
                        onChange={onChangeWhatDoYouSell} 
                    />
                </div> : <></>}
                {props.templateValue === 'Create Buyer Persona' ||
                props.templateValue === 'Create Long-Form Sales Letter' || props.templateValue === 'Create Video Sales Letter (VSL)'  ?  <div className="col-sm-6  mt-2">
                    <Form.Label htmlFor="whereDoYouSell">Where do you sell </Form.Label>
                    <Form.Control
                        value={whereDoYouSellValue}
                        type="text"
                        id="whereDoYouSell"
                        aria-describedby="Where do you sell"
                        onChange={onChangeWhereDoYouSell} 
                    />
                </div> : <></>}
                {props.templateValue === 'Create Long-Form Sales Letter' || 
                props.templateValue === 'Create Video Sales Letter (VSL)' ? <div className="col-sm-6  mt-2">
                    <Form.Label htmlFor="totalTitles">Total Words: </Form.Label>
                    <Form.Control
                        type="number"
                        min={1}
                        max={1000}
                        value={totalWordsValue}
                        id="totalWords"
                        aria-describedby="Total Words"
                        onChange={onChangeTotalWords}
                    />
                </div> : <></>}
                {props.templateValue === 'Create Video Sales Letter (VSL)' && <div className="col-sm-6  mt-2">
                    <Form.Label htmlFor="callToAction">Call To Action </Form.Label>
                    <Form.Control
                        value={callToActionValue}
                        type="text"
                        id="callToAction"
                        aria-describedby="Call To Action "
                        onChange={onChangeCallToAction} 
                    />
                </div>}
                {/* <div className="col-sm-12  mt-2">
                    <Form.Label htmlFor="ptemplate">Prompt Template</Form.Label>
                    <Form.Control 
                        id="ptemplate"
                        value={textareaValue}
                        onChange={onChangeTextarea}
                        as='textarea' 
                        rows={10}
                    />
                </div> */}
            </div>
            <div className="row">
                <div className="col-sm-12  mt-2">
                    <Button id="executeTemplate" 
                        onClick={executeTemplateButton} 
                        disabled={getButtonVisiblety()}
                    >Execute Template</Button>
                </div>
            </div>
        </div>
    )   
}

export default Marketing;


const indianLanguages: any = {
    "Assamese":"Assamese",
    "Bengali":"Bengali",
    "Bodo":"Bodo",
    "Dogri":"Dogri",
    "English": "English",
    "Gujarati":"Gujarati",
    "Hindi":"Hindi",
    "Kannada":"Kannada",
    "Kashmiri":"Kashmiri",
    "Konkani":"Konkani",
    "Maithili":"Maithili",
    "Malayalam":"Malayalam",
    "Marathi":"Marathi",
    "Meitei":"Meitei",
    "Nepali":"Nepali",
    "Odia":"Odia",
    "Punjabi":"Punjabi",
    "Sanskrit":"Sanskrit",
    "Santali":"Santali",
    "Sindhi":"Sindhi",
    "Tamil":"Tamil",
    "Telugu":"Telugu",
    "Urdu":"Urdu",
    "Other languages": "Other languages"
}

const languages: any = {
    "arabic": "Arabic",
    "bulgarian": "Bulgarian",
    "burmese": "Burmese",
    "czech": "Czech",
    "danish": "Danish",
    "dutch": "Dutch",
    "french": "French",
    "german": "German",
    "greek": "Greek",
    "hungarian": "Hungarian",
    "indonesian": "Indonesian",
    "italian": "Italian",
    "japanese": "Japanese",
    "javanese": "Javanese",
    "korean": "Korean",
    "mandarin chinese": "Mandarin Chinese",
    "polish": "Polish",
    "portuguese": "Portuguese",
    "romanian": "Romanian",
    "russian": "Russian",
    "spanish": "Spanish",
    "swedish": "Swedish",
    "thai": "Thai",
    "turkish": "Turkish",
    "ukranian": "Ukranian",
    "urdu": "Urdu",
    "vietnamese": "Vietnamese",
    "wu chinese": "Wu Chinese",
    "yue chinese": "Yue Chinese"
}

const voicetones: any = {
    "authoritative": "Authoritative",
    "caring": "Caring",
    "casual": "Casual",
    "cheerful": "Cheerful",
    "coarse": "Coarse",
    "conservative": "Conservative",
    "conversational": "Conversational",
    "creative": "Creative",
    "dry": "Dry",
    "edgy": "Edgy",
    "enthusiastic": "Enthusiastic",
    "expository": "Expository",
    "formal": "Formal",
    "frank": "Frank",
    "friendly": "Friendly",
    "fun": "Fun",
    "funny": "Funny",
    "humorous": "Humorous",
    "informative": "Informative",
    "irreverent": "Irreverent",
    "journalistic": "Journalistic",
    "matteroffact": "Matter of fact",
    "nostalgic": "Nostalgic",
    "objective": "Objective",
    "passionate": "Passionate",
    "poetic": "Poetic",
    "playful": "Playful",
    "professional": "Professional",
    "provocative": "Provocative",
    "quirky": "Quirky",
    "respectful": "Respectful",
    "romantic": "Romantic",
    "sarcastic": "Sarcastic",
    "serious": "Serious",
    "smart": "Smart",
    "snarky": "Snarky",
    "subjective": "Subjective",
    "sympathetic": "Sympathetic",
    "trendy": "Trendy",
    "trustworthy": "Trustworthy",
    "unapologetic": "Unapologetic",
    "upbeat": "Upbeat",
    "witty": "Witty"
}
const writingStyles: any = {
    "academic": "Academic",
    "analytical": "Analytical",
    "argumentative": "Argumentative",
    "conversational": "Conversational",
    "creative": "Creative",
    "critical": "Critical",
    "descriptive": "Descriptive",
    "epigrammatic": "Epigrammatic",
    "epistolary": "Epistolary",
    "expository": "Expository",
    "informative": "Informative",
    "instructive": "Instructive",
    "journalistic": "Journalistic",
    "metaphorical": "Metaphorical",
    "narrative": "Narrative",
    "persuasive": "Persuasive",
    "poetic": "Poetic",
    "satirical": "Satirical",
    "technical": "Technical"
}